// ================================
// WEEDO WORLD - REACT APP
// ================================
import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { SocketProvider } from './context/SocketContext';

// Customer
import CustomerLanding  from './pages/customer/Landing';
import CustomerLogin    from './pages/customer/Login';
import CustomerActivate from './pages/customer/Activate';
import CardRouter       from './pages/customer/CardRouter';
import CustomerSignup   from './pages/customer/Signup';
import CustomerDashboard from './pages/customer/Dashboard';
import CustomerOrder    from './pages/customer/Order';
import CustomerTrack    from './pages/customer/Track';
import CustomerWallet   from './pages/customer/Wallet';
import CustomerRewards  from './pages/customer/Rewards';

// Admin
import AdminLogin       from './pages/admin/Login';
import AdminDashboard   from './pages/admin/Dashboard';

// Driver
import DriverLogin      from './pages/driver/Login';
import DriverActivate   from './pages/driver/Activate';
import DriverQueue      from './pages/driver/Queue';

// Staff
import StaffLogin       from './pages/staff/Login';
import StaffActivate    from './pages/staff/Activate';
import StaffDashboard   from './pages/staff/Dashboard';

// Guards
import CustomerRoute    from './components/shared/CustomerRoute';
import AdminRoute       from './components/shared/AdminRoute';
import DriverRoute      from './components/shared/DriverRoute';
import StaffRoute       from './components/shared/StaffRoute';
import AppBackground    from './components/shared/AppBackground';

import './styles/global.css';

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <SocketProvider>
          <AppBackground />
          <Routes>
            {/* ── CUSTOMER ── */}
            <Route path="/"          element={<CustomerLanding />} />
            <Route path="/login"     element={<CustomerLogin />} />
            <Route path="/activate"  element={<CustomerActivate />} />
            <Route path="/c/:mid"    element={<CardRouter />} />
            <Route path="/signup"    element={<CustomerSignup />} />
            <Route path="/dashboard" element={<CustomerRoute><CustomerDashboard /></CustomerRoute>} />
            <Route path="/order"     element={<CustomerRoute><CustomerOrder /></CustomerRoute>} />
            <Route path="/track"     element={<CustomerRoute><CustomerTrack /></CustomerRoute>} />
            <Route path="/wallet"    element={<CustomerRoute><CustomerWallet /></CustomerRoute>} />
            <Route path="/rewards"   element={<CustomerRoute><CustomerRewards /></CustomerRoute>} />

            {/* ── ADMIN ── */}
            <Route path="/admin"          element={<AdminLogin />} />
            <Route path="/admin/dashboard" element={<AdminRoute><AdminDashboard /></AdminRoute>} />

            {/* ── DRIVER ── */}
            <Route path="/driver"       element={<DriverLogin />} />
            <Route path="/driver/activate" element={<DriverActivate />} />
            <Route path="/driver/queue" element={<DriverRoute><DriverQueue /></DriverRoute>} />

            {/* ── STAFF ── */}
            <Route path="/staff"          element={<StaffLogin />} />
            <Route path="/staff/activate" element={<StaffActivate />} />
            <Route path="/staff/dashboard" element={<StaffRoute><StaffDashboard /></StaffRoute>} />

            {/* Fallback */}
            <Route path="*" element={<Navigate to="/" />} />
          </Routes>
        </SocketProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}
